import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Grid } from 'semantic-ui-react';
import { Input, SelectableBlock } from '../../../Elements';
import Formsy from 'formsy-react';
import SignatureBlockShow from '../../Sections/SignatureBlocks/SignatureBlockShow';

class SelectSigner extends Component {
  static propTypes = {
    copyButton: PropTypes.func.isRequired,
    document: PropTypes.object.isRequired,
    next: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    selectSignatureBlock: PropTypes.func.isRequired,
    selectedSignatureBlock: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      showShareLink: !this.props.document.can_edit
    };
    this.getRemainingSigners = this.getRemainingSigners.bind(this);
    this.getShareUrl = this.getShareUrl.bind(this);
  }

  getRemainingSigners() {
    let remainingSigners = 0;
    this.props.document.contract_signature_blocks.edges.map(signatureBlock => {
      if (!signatureBlock.node.signed_at) {
        ++remainingSigners;
      }
      return signatureBlock;
    });
    return remainingSigners;
  }

  getShareUrl() {
    return `${process.env.BASE_URL}/open/c/${this.props.document.share_token}`;
  }

  render() {
    const {
      copyButton,
      document,
      next,
      onFocus,
      selectSignatureBlock,
      selectedSignatureBlock
    } = this.props;
    const { showShareLink } = this.state;
    return [
      <Grid.Row columns={1} key='SelectSigner'>
        <Grid.Column textAlign='left'>
          {document.can_edit &&
            <div>
              {this.getRemainingSigners() > 0 &&
                <h4>Please select who needs to sign this contract.</h4>}
              {!this.getRemainingSigners() > 0 &&
                document.contract_signature_blocks.edges.length > 0 &&
                <h4>All parties have signed this contract.</h4>}
              {!this.getRemainingSigners() > 0 &&
                document.contract_signature_blocks.edges.length === 0 &&
                <h4>
                  This contract contains no signature blocks. You must add
                  signature blocks before you can request signatures.
                </h4>}
              {document.contract_signature_blocks.edges.map(
                (signatureBlock, idx) =>
                  <div key={signatureBlock.node.id}>
                    <SelectableBlock
                      cardBorder
                      style={{ marginTop: '2em', padding: '0 1em' }}
                      onChange={() => selectSignatureBlock(idx)}
                      checked={
                        selectedSignatureBlock &&
                        selectedSignatureBlock.id === signatureBlock.node.id
                      }
                      disabled={
                        document.contract_signature_blocks.edges[idx].node
                          .signed_at && true
                      }
                      radio
                    >
                      <SignatureBlockShow
                        signatureBlock={signatureBlock}
                        withoutSignature
                      />
                    </SelectableBlock>
                  </div>
              )}
              <Divider style={{ margin: '2em auto' }} horizontal>
                Or
              </Divider>
            </div>}
          <h4 style={{ textAlign: 'left' }}>
            Sharing this contract with someone that isn't signing?
          </h4>
          {!showShareLink &&
            <div>
              <a onClick={() => this.setState({ showShareLink: true })}>
                Click here{' '}
              </a>
              to share a view-only version of this contract with anyone
            </div>}
          {showShareLink &&
            <Formsy.Form>
              <Input
                fluid
                name='share_url'
                onFocus={onFocus}
                value={this.getShareUrl()}
                onChange={() => {}}
                action={copyButton(this.getShareUrl())}
                style={{ marginTop: '2em', marginBottom: '2em' }}
              />
              Anyone with the link above <strong>can view</strong> this contract
              but <strong>cannot sign</strong>.
            </Formsy.Form>}
        </Grid.Column>
      </Grid.Row>,
      <Grid.Row columns='equal' verticalAlign='middle' key='controls'>
        <Grid.Column textAlign='right'>
          {this.getRemainingSigners() > 0 &&
            document.can_edit &&
            <Button
              primary
              disabled={!selectedSignatureBlock}
              content='Request Signature'
              onClick={next}
            />}
        </Grid.Column>
      </Grid.Row>
    ];
  }
}

export default SelectSigner;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/Share/SelectSigner.js